import { needsPriceFinalization } from '../../utils/pricingUtils';

const TERMINAL_PAYMENT_STATUSES = new Set(['cancelled', 'rejected', 'noshow']);

export const normalizePaymentStatus = (status) => (
  String(status || '').toLowerCase().replace(/[\s_-]/g, '')
);

export const canRecordManualPayment = ({ isAdmin, record, fallbackRequiresPayment = false }) => {
  if (!isAdmin || Number(record?.balanceDue) <= 0 || needsPriceFinalization(record)) return false;

  const status = normalizePaymentStatus(record?.status);
  if (TERMINAL_PAYMENT_STATUSES.has(status)) return false;

  const requiresPayment = record?.requiresPayment ?? fallbackRequiresPayment;
  const initialOnlinePaymentReceived = Number(record?.amountPaid) > 0;
  return requiresPayment !== true || initialOnlinePaymentReceived;
};

export const canPayAndCompleteManually = ({ sourceType, status, workflowInstanceId }) => {
  const normalizedType = String(sourceType || '').toLowerCase();
  const normalizedStatus = normalizePaymentStatus(status);

  if (normalizedType === 'booking') return normalizedStatus === 'inprogress';
  if (normalizedType === 'order') return normalizedStatus === 'readyforpickup';
  if (normalizedType === 'bookingrequest') {
    return normalizedStatus === 'inprogress' && !workflowInstanceId;
  }
  return false;
};
